export const IMAGE_URL =
  process.env.VUE_APP_API_BASE_URL + '/image/image-medium'
export const THUMBNAIL_URL =
  process.env.VUE_APP_API_BASE_URL + '/image/image-thumbnail'
export const EDITOR_IMG_UPLOAD_URL =
  process.env.VUE_APP_API_BASE_URL + '/api/editor_image'
export const EDITOR_IMG_BROWSE_URL =
  process.env.VUE_APP_API_BASE_URL + '/api/editor_images'
